import { combineReducers } from "redux";
import GlobalLoaderReducer from "../GlobalLoader/GlobalLoaderReducer";
import languageReducer from "../Home/HomeReducer";
import commonReducer from "../Common/CommonReducer";
import bibleReducer from "../Bible/BibleReducer";
import churchReducer from "../Church/ChurchReducer"
import userReducer from "../Users/reducer"
import plansReducer from "../Plan/reducer";
import groupsReducer from "../Group/reducer";
import prayerReducer from "../Prayer/PrayerReducer";
import commentReducer from "../comments/commentReducer";
const rootReducer = combineReducers({
  globalLoaderReducer: GlobalLoaderReducer,
  languageReducer: languageReducer,
  common: commonReducer,
  bible: bibleReducer,
  church:churchReducer,
  user:userReducer,
  plans: plansReducer,
  group:groupsReducer,
  prayer:prayerReducer,
  comment:commentReducer


});

export default rootReducer;
